import { apiClient } from "@api/client";
import { request } from "@api/request";
import type { components } from "@api/schema";

export interface Artifact {
  id: string;
  kind: string;
  filename: string | null;
  contentType: string;
  status: string;
  createdAt: string;
}

export const toArtifact = (
  a: components["schemas"]["ArtifactOut"],
): Artifact => ({
  id: a.uuid,
  kind: a.kind,
  filename: a.filename,
  contentType: a.content_type,
  status: a.status,
  createdAt: a.created_at,
});

export const artifactsClient = {
  list: (subject?: string) =>
    request(() =>
      apiClient.GET("/artifacts", {
        params: { query: subject ? { subject } : {} },
      }),
    ).then((rows) => rows.map(toArtifact)),

  getDownloadUrl: (id: string) =>
    request(() =>
      apiClient.GET("/artifacts/{artifact_uuid}", {
        params: { path: { artifact_uuid: id } },
      }),
    ).then((res) => res.download_url),
};
